var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "booking-form" },
    [
      _vm.$campaigns && _vm.$userIsAdmin
        ? _c("div", { staticClass: "panel panel-send-request" }, [
            _c("div", { staticClass: "panel-body" }, [
              _c("h3", [_vm._v("Assign to campaign")]),
              _vm._v(" "),
              _c("div", { staticClass: "flex w-full margin-t-4" }, [
                _c(
                  "div",
                  { staticClass: "w-3/4 margin-r-2" },
                  [
                    _c("selectize", {
                      ref: "campaigns",
                      staticClass: "selectize selectize-single w-full",
                      attrs: {
                        name: "campaign",
                        options: _vm.campaignOptions,
                        "fetch-results": _vm.getCampaigns,
                        "fetch-more-results": _vm.getNextCampaigns,
                        placeholder: "None",
                      },
                      model: {
                        value: _vm.$v.campaign_id.$model,
                        callback: function ($$v) {
                          _vm.$set(_vm.$v.campaign_id, "$model", $$v)
                        },
                        expression: "$v.campaign_id.$model",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-md btn-default flex-shrink-0",
                    attrs: { disabled: !_vm.campaign_id },
                    on: {
                      click: () => {
                        this.campaign_id = null
                      },
                    },
                  },
                  [_vm._v("Remove from campaign")]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "panel panel-send-request" }, [
        _c(
          "div",
          { staticClass: "panel-body" },
          [
            _c("h3", [
              _vm._v(
                _vm._s(_vm._f("sentenceCase")(_vm.$t("your deliverables")))
              ),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { class: _vm.hasErrorClass(_vm.$v.name, "form-group") },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* " + _vm._s(_vm.$t("request_stars.request_name"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.name.$model,
                      expression: "$v.name.$model",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "name",
                    type: "text",
                    placeholder: _vm.$tc("request_stars.activity_example"),
                  },
                  domProps: { value: _vm.$v.name.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.$v.name, "$model", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: { field: _vm.$v.name, label: "Name" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.$categoryModuleEnabled
              ? _c(
                  "div",
                  { class: _vm.hasErrorClass(_vm.$v.category, "form-group") },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("* " + _vm._s(_vm.$t("Request Category"))),
                    ]),
                    _vm._v(" "),
                    _c("selectize", {
                      key: "category",
                      staticClass: "selectize selectize-single",
                      attrs: {
                        name: "category_id",
                        options: _vm.categoryOptions,
                      },
                      model: {
                        value: _vm.$v.category.$model,
                        callback: function ($$v) {
                          _vm.$set(_vm.$v.category, "$model", $$v)
                        },
                        expression: "$v.category.$model",
                      },
                    }),
                    _vm._v(" "),
                    _c("vuelidate-help", {
                      attrs: {
                        field: _vm.$v.category,
                        label: _vm.$t("Category"),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$showDepartmentField &&
            (_vm.$userIsAdmin || (_vm.$userIsClient && _vm.$clientDepartment))
              ? _c(
                  "div",
                  {
                    class: _vm.hasErrorClass(
                      _vm.$v.department_id,
                      "form-group"
                    ),
                  },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(
                        "* " +
                          _vm._s(
                            _vm._f("titleCase")(_vm.$t("requesting department"))
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("department-selection", {
                      attrs: {
                        model: _vm.$v.department_id,
                        "additional-departments": _vm.additionalDepartments,
                        "show-label": false,
                        default: _vm.booking.department,
                        restricted_departments_only:
                          _vm.$userIsClient && _vm.$clientDepartment,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$isNflClient && _vm.$vlastMode
              ? _c("booking-field-input", {
                  staticStyle: { "text-transform": "capitalize" },
                  attrs: {
                    classes: _vm.hasErrorClass(
                      _vm.$v.nfl_event_type,
                      "form-group"
                    ),
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: "nfl_event_type",
                    "field-type": "select",
                    options: _vm.nflEventTypeOptions,
                    validations: _vm.$v.nfl_event_type,
                    label: "* NFL Event",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.$vlastMode
              ? _c("booking-field-input", {
                  staticStyle: { "text-transform": "capitalize" },
                  attrs: {
                    classes: _vm.hasErrorClass(_vm.$v.segment, "form-group"),
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: "segment",
                    "field-type": "select",
                    options: _vm.segmentOptions,
                    validations: _vm.$v.segment,
                    label: "* Segment",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.$vlastMode && _vm.booking.segment === "agency"
              ? _c("booking-field-input", {
                  attrs: {
                    classes: _vm.hasErrorClass(
                      _vm.$v.agency_stage,
                      "form-group"
                    ),
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: "agency_stage",
                    validations: _vm.$v.agency_stage,
                    "field-type": "select",
                    options: _vm.agencyStageOptions,
                    value: _vm.findAgencyStageText,
                    "other-classes": _vm.hasErrorClass(
                      _vm.$v.other_agency_stage,
                      "form-group"
                    ),
                    "other-field": "other_agency_stage",
                    "other-validations": _vm.$v.other_agency_stage,
                    label: "* Agency Stage",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.$vlastMode && _vm.booking.segment !== "fan"
              ? _c(
                  "div",
                  {
                    class: _vm.hasErrorClass(
                      _vm.$v.organisation_name,
                      "form-group"
                    ),
                  },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(
                        _vm._s(_vm._f("sentenceCase")(_vm.$t("organisation"))) +
                          " Name"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.$v.organisation_name.$model,
                          expression: "$v.organisation_name.$model",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { name: "name", type: "text" },
                      domProps: { value: _vm.$v.organisation_name.$model },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.$v.organisation_name,
                            "$model",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("vuelidate-help", {
                      attrs: {
                        field: _vm.$v.organisation_name,
                        label: _vm._f("sentenceCase")(
                          _vm.$t("organisation") + " Name"
                        ),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("booking-field-input", {
              attrs: {
                classes: _vm.hasErrorClass(_vm.$v.opportunities, "form-group"),
                validations: _vm.$v.opportunities,
                booking: _vm.booking,
                "property-mutator": _vm.propertyMutator,
                field: "opportunities",
                "field-type": "multi-select",
                "multi-select-types": [
                  "appearance_type",
                  "theme",
                  "event_type",
                  "opportunity_type",
                ],
                label: "* " + _vm.$t("Event Summary"),
              },
            }),
            _vm._v(" "),
            _vm.clientName === "auscricket"
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("booking-field-input", {
                        staticStyle: { "text-transform": "capitalize" },
                        attrs: {
                          classes: _vm.hasErrorClass(
                            _vm.$v.aca_event_location,
                            "form-group"
                          ),
                          booking: _vm.booking,
                          "property-mutator": _vm.propertyMutator,
                          field: "aca_event_location",
                          "field-type": "select",
                          options: _vm.acaLocationOptions,
                          validations: _vm.$v.aca_event_location,
                          label: "* " + _vm.$t("Request") + " Details",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("booking-field-input", {
                        staticStyle: { "text-transform": "capitalize" },
                        attrs: {
                          classes: _vm.hasErrorClass(
                            _vm.$v.aca_event_gender,
                            "form-group"
                          ),
                          booking: _vm.booking,
                          "property-mutator": _vm.propertyMutator,
                          field: "aca_event_gender",
                          "field-type": "select",
                          options: _vm.acaGenderOptions,
                          validations: _vm.$v.aca_event_gender,
                          label: "* Event Gender",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  this.aca_event_location === "Regional Event (100kms from CBD)"
                    ? _c(
                        "div",
                        {
                          staticClass: "col-md-6",
                          class: _vm.hasErrorClass(
                            _vm.$v.aca_event_distance,
                            "filter form-group"
                          ),
                        },
                        [
                          _c("label", { staticClass: "control-label" }, [
                            _vm._v("* Approximate distance from CBD"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.$v.aca_event_distance.$model,
                                  expression: "$v.aca_event_distance.$model",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "aca_event_distance" },
                              domProps: {
                                value: _vm.$v.aca_event_distance.$model,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.$v.aca_event_distance,
                                    "$model",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v("Appearance Type"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.displayAppearanceType,
                        expression: "displayAppearanceType",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      name: "appearance_type",
                      type: "text",
                      disabled: "",
                    },
                    domProps: { value: _vm.displayAppearanceType },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.displayAppearanceType = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _vm.showOnlineBooking
                ? _c("div", { staticClass: "col-md-6" }, [
                    !_vm.$vlastMode
                      ? _c(
                          "div",
                          {
                            class: _vm.hasErrorClass(
                              _vm.$v.complete_by_date,
                              "form-group calendar-group"
                            ),
                          },
                          [
                            _c("label", { staticClass: "control-label" }, [
                              !_vm.$vlastMode
                                ? _c("span", [_vm._v("*")])
                                : _vm._e(),
                              _vm._v("Online Deliverables Complete By Date"),
                            ]),
                            _vm._v(" "),
                            _c("flat-pickr", {
                              staticClass: "form-control pickdate",
                              attrs: {
                                config: _vm.flatPickerSingleDateConfig,
                                placeholder: "Please select a date",
                                name: "complete_by_date",
                              },
                              model: {
                                value: _vm.$v.complete_by_date.$model,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.$v.complete_by_date,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression: "$v.complete_by_date.$model",
                              },
                            }),
                            _vm._v(" "),
                            _c("vuelidate-help", {
                              attrs: {
                                field: _vm.$v.complete_by_date,
                                label: "Complete By Date",
                                "custom-messages": {
                                  insideDateBounds:
                                    _vm.selectCampaignOptionErrorMessage,
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.showCriticalChangeWarnings
                              ? _c("info-alert", {
                                  attrs: {
                                    type: "warning",
                                    message: `Changing the date(s) will notify ${_vm.$starLabelPlural} and require them to re-apply`,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            class: _vm.hasErrorClass(
                              _vm.$v.video_url,
                              "form-group"
                            ),
                          },
                          [
                            _c("label", { staticClass: "control-label" }, [
                              _vm._v("Video URL"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.$v.video_url.$model,
                                  expression: "$v.video_url.$model",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "video_url", type: "text" },
                              domProps: { value: _vm.$v.video_url.$model },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.$v.video_url,
                                    "$model",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("vuelidate-help", {
                              attrs: {
                                field: _vm.$v.video_url,
                                label: "Video URL",
                              },
                            }),
                          ],
                          1
                        ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showOnlineBooking
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      {
                        class: _vm.hasErrorClass(
                          _vm.$v.duration,
                          "form-group calendar-group"
                        ),
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v("Duration"),
                        ]),
                        _vm._v(" "),
                        _c("selectize", {
                          staticClass: "selectize selectize-single",
                          attrs: {
                            name: "duration",
                            placeholder: "Please select",
                            options: _vm.opportunityDurationOptions,
                          },
                          model: {
                            value: _vm.$v.duration.$model,
                            callback: function ($$v) {
                              _vm.$set(_vm.$v.duration, "$model", $$v)
                            },
                            expression: "$v.duration.$model",
                          },
                        }),
                        _vm._v(" "),
                        _c("vuelidate-help", {
                          attrs: { field: _vm.$v.duration, label: "Duration" },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            [
              _c("div", { staticClass: "row" }, [
                _vm.showInPersonBooking ||
                (_vm.$vlastMode && _vm.showOnlineBooking) ||
                (_vm.$vlastMode && _vm.$offersModuleEnabled)
                  ? _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        {
                          class: _vm.hasErrorClass(
                            _vm.$v.date,
                            "form-group calendar-group"
                          ),
                        },
                        [
                          _vm.$vlastMode && _vm.$isOtis
                            ? _c("label", { staticClass: "control-label" }, [
                                _vm._v(
                                  "* " + _vm._s(_vm.$t("Request")) + " Date"
                                ),
                              ])
                            : _c("label", { staticClass: "control-label" }, [
                                _vm._v("* Date"),
                              ]),
                          _vm._v(" "),
                          this.$vlastMode && _vm.$allowBookingDateRange
                            ? _c("flat-pickr", {
                                staticClass: "form-control pickdate",
                                attrs: {
                                  config: _vm.flatPickerRangeDateConfig,
                                  placeholder: "Please select a date",
                                  name: "date",
                                },
                                model: {
                                  value: _vm.$v.date.$model,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.$v.date, "$model", $$v)
                                  },
                                  expression: "$v.date.$model",
                                },
                              })
                            : _c("flat-pickr", {
                                staticClass: "form-control pickdate",
                                attrs: {
                                  config: _vm.flatPickerSingleDateConfig,
                                  placeholder: "Please select a date",
                                  name: "date",
                                },
                                model: {
                                  value: _vm.$v.date.$model,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.$v.date, "$model", $$v)
                                  },
                                  expression: "$v.date.$model",
                                },
                              }),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: {
                              field: _vm.$v.date,
                              label: "Date",
                              "custom-messages": {
                                insideDateBounds:
                                  _vm.selectCampaignOptionErrorMessage,
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.showCriticalChangeWarnings
                            ? _c("info-alert", {
                                attrs: {
                                  type: "warning",
                                  message: `Changing the date(s) will notify ${_vm.$starLabelPlural} and require them to re-apply`,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$isNflClient && !_vm.booking.is_offer
                  ? _c("div", { staticClass: "col-md-6 margin-b-2" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(" "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flexibleItem" },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("Request")) +
                                " " +
                                _vm._s(_vm.$t("date is flexible")) +
                                "\n\n                  "
                            ),
                            _c("toggle-button", {
                              staticClass: "pull-right date_unconfirmed",
                              attrs: {
                                sync: true,
                                color: {
                                  checked: _vm.brandPrimary,
                                  unchecked: "#b7b7b7",
                                },
                              },
                              model: {
                                value:
                                  _vm.$v.date_flexible_or_unconfirmed.$model,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.$v.date_flexible_or_unconfirmed,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression:
                                  "$v.date_flexible_or_unconfirmed.$model",
                              },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                type: "hidden",
                                name: "date_flexible_or_unconfirmed",
                              },
                              domProps: {
                                value:
                                  _vm.$v.date_flexible_or_unconfirmed.$model,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.showInPersonBooking &&
              _vm.$v.date_flexible_or_unconfirmed.$model &&
              !_vm.booking.is_offer
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        class: _vm.hasErrorClass(
                          _vm.$v.date2,
                          "form-group calendar-group"
                        ),
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v("Date Option 2"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "form-group input-group calendar-group",
                          },
                          [
                            _c("flat-pickr", {
                              staticClass: "form-control pickdate",
                              attrs: {
                                config: _vm.flatPickerSingleDateConfig,
                                placeholder: "Please select a date",
                                name: "date2",
                              },
                              model: {
                                value: _vm.$v.date2.$model,
                                callback: function ($$v) {
                                  _vm.$set(_vm.$v.date2, "$model", $$v)
                                },
                                expression: "$v.date2.$model",
                              },
                            }),
                            _vm._v(" "),
                            _vm._m(0),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("vuelidate-help", {
                          attrs: {
                            field: _vm.$v.date2,
                            label: "Date option 2",
                            "custom-messages": {
                              insideDateBounds:
                                _vm.selectCampaignOptionErrorMessage,
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showInPersonBooking &&
              _vm.$v.date_flexible_or_unconfirmed.$model &&
              !_vm.booking.is_offer
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        class: _vm.hasErrorClass(
                          _vm.$v.date3,
                          "form-group calendar-group"
                        ),
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v("Date Option 3"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "form-group input-group calendar-group",
                          },
                          [
                            _c("flat-pickr", {
                              staticClass: "form-control pickdate",
                              attrs: {
                                config: _vm.flatPickerSingleDateConfig,
                                placeholder: "Please select a date",
                                name: "date3",
                              },
                              model: {
                                value: _vm.$v.date3.$model,
                                callback: function ($$v) {
                                  _vm.$set(_vm.$v.date3, "$model", $$v)
                                },
                                expression: "$v.date3.$model",
                              },
                            }),
                            _vm._v(" "),
                            _vm._m(1),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("vuelidate-help", {
                          attrs: {
                            field: _vm.$v.date3,
                            label: "Date option 3",
                            "custom-messages": {
                              insideDateBounds:
                                _vm.selectCampaignOptionErrorMessage,
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              (_vm.showInPersonBooking ||
                (_vm.$vlastMode && _vm.showOnlineBooking)) &&
              !_vm.booking.is_offer
                ? _c("div", { staticClass: "row equal-cols" }, [
                    _vm.showInPersonBooking
                      ? _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              class: _vm.hasErrorClass(
                                _vm.$v.arrival_time,
                                "form-group calendar-group"
                              ),
                            },
                            [
                              _vm.$vlastMode
                                ? _c(
                                    "label",
                                    { staticClass: "control-label" },
                                    [_vm._v("* Arrival Time")]
                                  )
                                : _c(
                                    "label",
                                    { staticClass: "control-label" },
                                    [_vm._v("Arrival Time")]
                                  ),
                              _vm._v(" "),
                              _c("flat-pickr", {
                                staticClass: "form-control pickdate",
                                attrs: {
                                  config: _vm.flatPickerTimeConfig,
                                  placeholder: "2:15pm",
                                  name: "arrival_time",
                                  step: "60",
                                },
                                model: {
                                  value: _vm.$v.arrival_time.$model,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.$v.arrival_time, "$model", $$v)
                                  },
                                  expression: "$v.arrival_time.$model",
                                },
                              }),
                              _vm._v(" "),
                              _c("vuelidate-help", {
                                attrs: {
                                  field: _vm.$v.arrival_time,
                                  label: "Arrival time",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        {
                          class: _vm.hasErrorClass(
                            _vm.$v.athlete_start_time,
                            "form-group calendar-group"
                          ),
                        },
                        [
                          _c("label", { staticClass: "control-label" }, [
                            _vm._v(
                              _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)) +
                                " Start Time"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("flat-pickr", {
                            staticClass: "form-control pickdate",
                            attrs: {
                              config: _vm.flatPickerTimeConfig,
                              placeholder: "2:30pm",
                              name: "athlete_start_time",
                              step: "60",
                            },
                            model: {
                              value: _vm.$v.athlete_start_time.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.athlete_start_time,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.athlete_start_time.$model",
                            },
                          }),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: {
                              field: _vm.$v.athlete_start_time,
                              label: "Start time",
                              "custom-messages": {
                                afterArrivalTime:
                                  "Start time cannot be before arrival time",
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        {
                          class: _vm.hasErrorClass(
                            _vm.$v.athlete_leave_time,
                            "form-group calendar-group"
                          ),
                        },
                        [
                          _c("label", { staticClass: "control-label" }, [
                            _vm._v(
                              _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)) +
                                " Finish Time"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("flat-pickr", {
                            staticClass: "form-control pickdate",
                            attrs: {
                              config: _vm.flatPickerTimeConfig,
                              placeholder: "3:30pm",
                              name: "athlete_leave_time",
                              step: "60",
                            },
                            model: {
                              value: _vm.$v.athlete_leave_time.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.athlete_leave_time,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.athlete_leave_time.$model",
                            },
                          }),
                          _vm._v(" "),
                          this.$vlastMode
                            ? _c("vuelidate-help", {
                                attrs: {
                                  field: _vm.$v.athlete_leave_time,
                                  label: "Leave time",
                                  "custom-messages": {
                                    afterArrivalTime:
                                      "Leave time must be after arrival time",
                                    afterStartTime:
                                      "Leave time must be after or the same with start time",
                                  },
                                },
                              })
                            : _c("vuelidate-help", {
                                attrs: {
                                  field: _vm.$v.athlete_leave_time,
                                  label: "Leave time",
                                  "custom-messages": {
                                    afterArrivalTime:
                                      "Leave time must be after arrival time",
                                    afterStartTime:
                                      "Leave time must be after start time",
                                  },
                                },
                              }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.$hideTravelTime && _vm.showInPersonBooking
                      ? _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "form-group calendar-group" },
                            [
                              _c("label", { staticClass: "control-label" }, [
                                _vm._v("Travel Time"),
                              ]),
                              _vm._v(" "),
                              _c("selectize", {
                                staticClass: "selectize selectize-single",
                                attrs: {
                                  name: "duration",
                                  placeholder: "Please select",
                                  options: _vm.travelDurationOptions,
                                },
                                model: {
                                  value: _vm.$v.travel_time.$model,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.$v.travel_time, "$model", $$v)
                                  },
                                  expression: "$v.travel_time.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _vm.showDurationField
                      ? _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { staticClass: "control-label" }, [
                                _vm._v(_vm._s(_vm.durationFieldLabel)),
                              ]),
                              _vm._v(" "),
                              _c("selectize", {
                                staticClass: "selectize selectize-single",
                                attrs: {
                                  name: "duration",
                                  placeholder: "Please select",
                                  options: _vm.opportunityDurationOptions,
                                },
                                model: {
                                  value: _vm.$v.duration.$model,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.$v.duration, "$model", $$v)
                                  },
                                  expression: "$v.duration.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showInPersonBooking &&
              !_vm.$isNflClient &&
              !_vm.booking.is_offer
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      { staticClass: "flexibleItem" },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("Are these times flexible?")) +
                            "\n\n              "
                        ),
                        _c("toggle-button", {
                          staticClass: "pull-right date_unconfirmed",
                          attrs: {
                            sync: true,
                            color: {
                              checked: _vm.brandPrimary,
                              unchecked: "#b7b7b7",
                            },
                          },
                          model: {
                            value: _vm.$v.time_flexible_or_unconfirmed.$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.time_flexible_or_unconfirmed,
                                "$model",
                                $$v
                              )
                            },
                            expression:
                              "$v.time_flexible_or_unconfirmed.$model",
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: {
                            type: "hidden",
                            name: "time_flexible_or_unconfirmed",
                          },
                          domProps: {
                            value: _vm.$v.time_flexible_or_unconfirmed.$model,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showInPersonBooking && !_vm.$isNflClient
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      { staticClass: "flexibleItem" },
                      [
                        _vm._v(
                          "\n              Location unconfirmed?\n\n              "
                        ),
                        _c("toggle-button", {
                          staticClass: "pull-right date_unconfirmed",
                          attrs: {
                            sync: true,
                            color: {
                              checked: _vm.brandPrimary,
                              unchecked: "#b7b7b7",
                            },
                          },
                          model: {
                            value: _vm.$v.location_unconfirmed.$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.location_unconfirmed,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.location_unconfirmed.$model",
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: {
                            type: "hidden",
                            name: "date_flexible_or_unconfirmed",
                          },
                          domProps: {
                            value: _vm.$v.location_unconfirmed.$model,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showInPersonBooking
                ? _c(
                    "div",
                    { class: _vm.hasErrorClass(_vm.$v.location, "form-group") },
                    [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v("Location"),
                      ]),
                      _vm._v(" "),
                      _c("gmap-autocomplete", {
                        staticClass: "form-control",
                        attrs: {
                          name: "location",
                          placeholder: _vm.$tc(
                            "request_stars.location_example"
                          ),
                          value: _vm.booking.address,
                          options: _vm.googleMapOptions,
                          bounds: _vm.googleMapOptions.bounds,
                        },
                        on: { place_changed: _vm.handleAddressChangeCallback },
                        nativeOn: {
                          input: function ($event) {
                            return _vm.handleResetAddressCallback.apply(
                              null,
                              arguments
                            )
                          },
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "street_address" },
                        domProps: { value: _vm.$v.street_address.$model },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "suburb" },
                        domProps: { value: _vm.$v.suburb.$model },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "area" },
                        domProps: { value: _vm.$v.area.$model },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "state" },
                        domProps: { value: _vm.$v.state.$model },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "country" },
                        domProps: { value: _vm.$v.country.$model },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "postcode" },
                        domProps: { value: _vm.$v.postcode.$model },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "latitude" },
                        domProps: { value: _vm.$v.latitude.$model },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "longitude" },
                        domProps: { value: _vm.$v.longitude.$model },
                      }),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: { field: _vm.$v.location, label: "Location" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showInPersonBooking
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("Additional Location Detail "),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.$v.additional_location_detail.$model,
                          expression: "$v.additional_location_detail.$model",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: "additional_location_detail",
                        type: "text",
                        placeholder: _vm.$tc("Additional Location Placeholder"),
                      },
                      domProps: {
                        value: _vm.$v.additional_location_detail.$model,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.$v.additional_location_detail,
                            "$model",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
            ],
            _vm._v(" "),
            _vm.$vlastMode &&
            _vm.monetaryCurrency &&
            _vm.$userIsAdmin &&
            _vm.$requestFormConfig.show_commission &&
            !_vm.booking.is_offer
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-6 col-md-6" }, [
                    _c(
                      "div",
                      {
                        class: _vm.hasErrorClass(
                          _vm.$v.commission_rate,
                          "filter form-group"
                        ),
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(
                            _vm._s(_vm.clientName) +
                              " commission per " +
                              _vm._s(_vm.$starLabel.toLowerCase())
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-5 col-md-5" },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.$v.commission_rate.$model,
                                      expression: "$v.commission_rate.$model",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    name: "commission_rate",
                                    type: "number",
                                    min: "0",
                                    autocomplete: "off",
                                    disabled: !!_vm.$v.commission_dollar.$model,
                                  },
                                  domProps: {
                                    value: _vm.$v.commission_rate.$model,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.$v.commission_rate,
                                        "$model",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm._m(3),
                              ]),
                              _vm._v(" "),
                              _c("vuelidate-help", {
                                attrs: {
                                  field: _vm.$v.commission_rate,
                                  label: "commission rate",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-sm-1 col-md-1",
                              staticStyle: {
                                padding: "0",
                                "padding-top": "10px",
                                "text-align": "center",
                              },
                            },
                            [_vm._v("OR")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-5 col-md-5" }, [
                            _c(
                              "div",
                              {
                                class: _vm.hasErrorClass(
                                  _vm.$v.commission_dollar,
                                  "filter form-group"
                                ),
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.$v.commission_dollar.$model,
                                        expression:
                                          "$v.commission_dollar.$model",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      name: "commission_dollar",
                                      type: "text",
                                      disabled: !!_vm.$v.commission_rate.$model,
                                    },
                                    domProps: {
                                      value: _vm.$v.commission_dollar.$model,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.$v.commission_dollar,
                                          "$model",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("vuelidate-help", {
                                  attrs: {
                                    field: _vm.$v.commission_dollar,
                                    label: "Commission",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.$costReferences &&
              (_vm.$clientSetsBudget || _vm.$userIsAdmin) &&
              !_vm.booking.is_offer
                ? _c("div", { staticClass: "col-sm-4 col-md-3" }, [
                    _c(
                      "div",
                      {
                        class: _vm.hasErrorClass(
                          _vm.$v.budget_per_star,
                          "filter form-group"
                        ),
                      },
                      [
                        _vm.$vlastMode && _vm.$isOtis
                          ? _c("label", {
                              staticClass: "control-label",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.booking.currency === "points"
                                    ? _vm.$t("Request") + " Points"
                                    : _vm.$t("Request") +
                                        " " +
                                        _vm.$options.filters.sentenceCase(
                                          _vm.$t("budget")
                                        )
                                ),
                              },
                            })
                          : _c("label", {
                              staticClass: "control-label",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.booking.currency === "points"
                                    ? "Points per " +
                                        _vm.$starLabel.toLowerCase()
                                    : _vm.$options.filters.sentenceCase(
                                        _vm.$t("budget")
                                      ) +
                                        " per " +
                                        _vm.$starLabel.toLowerCase()
                                ),
                              },
                            }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group form-group" }, [
                          _c("span", { staticClass: "input-group-addon" }, [
                            _vm._v(_vm._s(_vm.moneySymbol)),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.budget_per_star.$model,
                                expression: "$v.budget_per_star.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              disabled: !!(
                                !_vm.booking.id &&
                                _vm.$opportunityPointsModuleEnabled
                              ),
                              id: "budget",
                              name: "budget_per_star",
                              type: "text",
                              placeholder: "0",
                            },
                            domProps: { value: _vm.$v.budget_per_star.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.budget_per_star,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("vuelidate-help", {
                          attrs: {
                            field: _vm.$v.budget_per_star,
                            label: "Budget",
                          },
                        }),
                        _vm._v(" "),
                        _vm.showBudgetAlert
                          ? _c("info-alert", {
                              attrs: {
                                type: "warning",
                                message: `Changing the budget will notify ${_vm.$starLabelPlural} and require them to re-apply`,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$vlastMode &&
              !_vm.$isQas &&
              _vm.$budgetCode &&
              !_vm.booking.is_offer
                ? _c("div", { staticClass: "col-sm-4 col-md-3" }, [
                    _c(
                      "div",
                      {
                        class: _vm.hasErrorClass(
                          _vm.$v.budget_code,
                          "filter form-group"
                        ),
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v("Budget Code"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group w-full" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.budget_code.$model,
                                expression: "$v.budget_code.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "budget_code", type: "text" },
                            domProps: { value: _vm.$v.budget_code.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.budget_code,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("vuelidate-help", {
                          attrs: {
                            field: _vm.$v.budget_code,
                            label: "Budget code",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$vlastMode &&
              _vm.$isQas &&
              _vm.$userIsAdmin &&
              (_vm.$budgetCode || !_vm.$budgetCode) &&
              !_vm.booking.is_offer
                ? _c("div", { staticClass: "col-sm-4 col-md-3" }, [
                    _c(
                      "div",
                      {
                        class: _vm.hasErrorClass(
                          _vm.$v.cost_centre,
                          "filter form-group"
                        ),
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v("Cost Centre"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group w-full" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.cost_centre.$model,
                                expression: "$v.cost_centre.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "cost_centre", type: "text" },
                            domProps: { value: _vm.$v.cost_centre.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.cost_centre,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("vuelidate-help", {
                          attrs: {
                            field: _vm.$v.cost_centre,
                            label: "Cost centre",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$vlastMode &&
              _vm.$isQas &&
              _vm.$userIsAdmin &&
              (_vm.$budgetCode || !_vm.$budgetCode) &&
              !_vm.booking.is_offer
                ? _c("div", { staticClass: "col-sm-4 col-md-3" }, [
                    _c(
                      "div",
                      {
                        class: _vm.hasErrorClass(
                          _vm.$v.gl_code,
                          "filter form-group"
                        ),
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v("GL Code"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group w-full" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.gl_code.$model,
                                expression: "$v.gl_code.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "cost_centre", type: "text" },
                            domProps: { value: _vm.$v.gl_code.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.gl_code,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("vuelidate-help", {
                          attrs: { field: _vm.$v.gl_code, label: "GL Code" },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4 col-md-3" }, [
                _c(
                  "div",
                  {
                    class: _vm.hasErrorClass(
                      _vm.$v.required_stars,
                      "filter form-group"
                    ),
                  },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("* I am looking for"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _vm.$vlastMode &&
                      _vm.$offersModuleEnabled &&
                      _vm.booking.is_offer
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.required_stars.$model,
                                expression: "$v.required_stars.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              name: "required_stars",
                              type: "number",
                              min: "0",
                            },
                            domProps: { value: _vm.$v.required_stars.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.required_stars,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.required_stars.$model,
                                expression: "$v.required_stars.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              name: "required_stars",
                              type: "number",
                              min: "1",
                            },
                            domProps: { value: _vm.$v.required_stars.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.required_stars,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                      _vm._v(" "),
                      _c("span", { staticClass: "input-group-addon" }, [
                        _vm._v(
                          _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)) + "(s)"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("vuelidate-help", {
                      attrs: {
                        field: _vm.$v.required_stars,
                        label: `Number of ${_vm.$starLabelPlural}`,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.$costReferences &&
            (_vm.$clientSetsBudget || _vm.$userIsAdmin) &&
            !_vm.booking.is_offer
              ? _c(
                  "div",
                  {
                    staticClass: "col-sm-10 col-md-8",
                    staticStyle: {
                      "text-align": "left",
                      "padding-left": "10px",
                    },
                  },
                  [
                    _vm.$vlastMode
                      ? [
                          this.$isACA
                            ? [_vm._m(5)]
                            : [
                                _vm.booking.currency !== "points"
                                  ? _c("p", [
                                      _vm._v(
                                        "Total " +
                                          _vm._s(_vm.$t("budget")) +
                                          " " +
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.bookingTotalBudget,
                                              _vm.booking.currency
                                            )
                                          ) +
                                          " "
                                      ),
                                      _vm.$v.commission_dollar.$model ||
                                      _vm.$v.commission_rate.$model
                                        ? _c("span", [
                                            _vm._v(
                                              " (" +
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    _vm.bookingTotalBudgetWithoutCommission,
                                                    _vm.booking.currency
                                                  )
                                                ) +
                                                ")"
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$showTax ? " (plus tax)" : ""
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                        ]
                      : [
                          _c("p", [
                            _vm._v(
                              "Total " +
                                _vm._s(
                                  _vm._f("currency")(
                                    _vm.bookingTotalBudget,
                                    _vm.booking.currency
                                  )
                                )
                            ),
                          ]),
                        ],
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$costReferences &&
            (_vm.$clientSetsBudget || _vm.$userIsAdmin) &&
            !_vm.booking.is_offer
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm.$requestFormConfig.allow_unconfirmed_budgets
                        ? _c(
                            "div",
                            { staticClass: "flexibleItem" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("sentenceCase")(_vm.$t("budget"))
                                  ) +
                                  " unconfirmed?\n\n                "
                              ),
                              _c("toggle-button", {
                                staticClass: "pull-right date_unconfirmed",
                                attrs: {
                                  sync: true,
                                  color: {
                                    checked: _vm.brandPrimary,
                                    unchecked: "#b7b7b7",
                                  },
                                },
                                model: {
                                  value: _vm.$v.budget_not_confirmed.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.budget_not_confirmed,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.budget_not_confirmed.$model",
                                },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "budget_not_confirmed",
                                },
                                domProps: {
                                  value: _vm.$v.budget_not_confirmed.$model,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$userIsAdmin && _vm.$vlastMode && !_vm.booking.is_offer
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "flexibleItem" },
                        [
                          _vm._v(
                            "\n                Do you want the " +
                              _vm._s(_vm.$starLabel) +
                              " to view all booked " +
                              _vm._s(_vm.$starLabel) +
                              " profiles for this request?\n\n                "
                          ),
                          _c("toggle-button", {
                            staticClass: "pull-right",
                            attrs: {
                              sync: true,
                              color: {
                                checked: _vm.brandPrimary,
                                unchecked: "#b7b7b7",
                              },
                            },
                            model: {
                              value: _vm.$v.show_all_talents.$model,
                              callback: function ($$v) {
                                _vm.$set(_vm.$v.show_all_talents, "$model", $$v)
                              },
                              expression: "$v.show_all_talents.$model",
                            },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "show_all_talents" },
                            domProps: { value: _vm.$v.show_all_talents.$model },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.bookingAppearanceInPerson && _vm.showMap
        ? _c(
            "div",
            { staticClass: "event-map" },
            [
              _c(
                "gmap-map",
                {
                  ref: "eventMap",
                  attrs: {
                    center: {
                      lat: _vm.$v.latitude.$model || _vm.defaultLatLng.lat,
                      lng: _vm.$v.longitude.$model || _vm.defaultLatLng.lng,
                    },
                    zoom:
                      _vm.$v.latitude.$model && _vm.$v.longitude.$model
                        ? 10
                        : _vm.defaultLatLng.zoom,
                  },
                },
                [
                  _c("gmap-marker", {
                    attrs: { position: _vm.bookingLatitudeAndLongitude },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fieldSetSelected("social_post")
        ? _c("div", { staticClass: "panel panel-send-request" }, [
            _c(
              "div",
              { staticClass: "panel-body" },
              [
                _c("h3", [_vm._v("Social Post Details")]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: _vm.hasErrorClass(_vm.$v.post_caption, "form-group"),
                  },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("\n            Social Content\n          "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "redactor-editor-wrapper" },
                      [
                        _c("redactor", {
                          attrs: {
                            name: "post_caption",
                            options: _vm.redactorOptions,
                          },
                          model: {
                            value: _vm.$v.post_caption.$model,
                            callback: function ($$v) {
                              _vm.$set(_vm.$v.post_caption, "$model", $$v)
                            },
                            expression: "$v.post_caption.$model",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.displayMarketingDisclaimer
                  ? _c("p", { staticClass: "requirements-info" }, [
                      _vm._v(
                        "\n          Important: When talent are required to complete a promotional or branded post on their social media accounts, it is likely this will need to be disclosed as advertising (e.g. #ad or #spon). To find out if this is relevant to you, read more "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            target: "_blank",
                            href: _vm.socialMediaDisclosureLink,
                          },
                        },
                        [_vm._v("here")]
                      ),
                      _vm._v(" or email "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "mailto:" + _vm.$user.region.admin_email,
                          },
                        },
                        [_vm._v(_vm._s(_vm.$user.region.admin_email))]
                      ),
                      _vm._v(" if you have any questions.\n        "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("booking-field-input", {
                  attrs: {
                    classes: _vm.hasErrorClass(
                      _vm.$v.social_post_location,
                      "form-group"
                    ),
                    validations: _vm.$v.social_post_location,
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: "social_post_location",
                    "field-type": "select",
                    options: _vm.socialLocationOptions,
                    label: "* Social Post Location",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: _vm.hasErrorClass(
                      _vm.$v.number_of_social_media_posts,
                      "filter form-group"
                    ),
                  },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("* Number of posts required"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.number_of_social_media_posts.$model,
                            expression:
                              "$v.number_of_social_media_posts.$model",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          name: "number_of_posts_required",
                          type: "number",
                          min: "1",
                        },
                        domProps: {
                          value: _vm.$v.number_of_social_media_posts.$model,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.number_of_social_media_posts,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "input-group-addon" }, [
                        _vm._v("Post(s)"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("vuelidate-help", {
                      attrs: {
                        field: _vm.$v.number_of_social_media_posts,
                        label: "Number of posts",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showPaidAdvertising
                  ? _c("ul", { staticClass: "more-details" }, [
                      _c(
                        "li",
                        [
                          _vm._v(
                            "\n            Will this be used In Paid Advertising\n            "
                          ),
                          _c("toggle-button", {
                            staticClass: "pull-right",
                            attrs: {
                              sync: true,
                              color: {
                                checked: _vm.brandPrimary,
                                unchecked: "#b7b7b7",
                              },
                            },
                            model: {
                              value: _vm.$v.paid_advertising.$model,
                              callback: function ($$v) {
                                _vm.$set(_vm.$v.paid_advertising, "$model", $$v)
                              },
                              expression: "$v.paid_advertising.$model",
                            },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "paid_advertising" },
                            domProps: { value: _vm.$v.paid_advertising.$model },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$v.paid_advertising.$model
                  ? _c("booking-field-input", {
                      attrs: {
                        classes: _vm.hasErrorClass(
                          _vm.$v.rights_length,
                          "form-group"
                        ),
                        validations: _vm.$v.rights_length,
                        booking: _vm.booking,
                        "property-mutator": _vm.propertyMutator,
                        field: "rights_length",
                        "field-type": "select",
                        options: _vm.socialLengthOptions,
                        label: "Rights Length",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.fieldSetSelected("ambassador")
        ? _c("div", { staticClass: "panel panel-send-request" }, [
            _c(
              "div",
              { staticClass: "panel-body" },
              [
                _c("h3", [_vm._v("Brand Ambassador Details")]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("booking-field-input", {
                  attrs: {
                    classes: _vm.hasErrorClass(
                      _vm.$v.ambassador_length,
                      "form-group"
                    ),
                    validations: _vm.$v.ambassador_length,
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: "ambassador_length",
                    "field-type": "select",
                    options: _vm.ambassadorLengthOptions,
                    label: "* Ambassador Length",
                  },
                }),
                _vm._v(" "),
                _c("booking-field-input", {
                  attrs: {
                    classes: _vm.hasErrorClass(
                      _vm.$v.target_market,
                      "form-group"
                    ),
                    validations: _vm.$v.target_market,
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: "target_market",
                    label: "* Target Market",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: _vm.hasErrorClass(
                      _vm.$v.ambassadorship_details,
                      "form-group"
                    ),
                  },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(
                        "\n            Ambassadorship Details\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "redactor-editor-wrapper" },
                      [
                        _c("redactor", {
                          attrs: {
                            name: "ambassadorship_details",
                            placeholder:
                              "Add any further details you may have about this ambassadorship",
                            options: _vm.redactorOptions,
                          },
                          model: {
                            value: _vm.$v.ambassadorship_details.$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.ambassadorship_details,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.ambassadorship_details.$model",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "div",
                    {
                      class: _vm.hasErrorClass(
                        _vm.$v.commencement_date,
                        "form-group calendar-group"
                      ),
                    },
                    [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v("* Commencement Date"),
                      ]),
                      _vm._v(" "),
                      _c("flat-pickr", {
                        staticClass: "form-control pickdate",
                        attrs: {
                          config: _vm.flatPickerSingleDateConfig,
                          placeholder: "Please select a date",
                          name: "commencement_date",
                        },
                        model: {
                          value: _vm.$v.commencement_date.$model,
                          callback: function ($$v) {
                            _vm.$set(_vm.$v.commencement_date, "$model", $$v)
                          },
                          expression: "$v.commencement_date.$model",
                        },
                      }),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: {
                          field: _vm.$v.commencement_date,
                          label: "Commencement Date",
                          "custom-messages": {
                            insideDateBounds:
                              _vm.selectCampaignOptionErrorMessage,
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.fieldSetSelected("marketing_campaign")
                  ? _c(
                      "div",
                      [
                        _c("booking-field-input", {
                          attrs: {
                            classes: _vm.hasErrorClass(
                              _vm.$v.marketing_channels,
                              "form-group"
                            ),
                            validations: _vm.$v.marketing_channels,
                            booking: _vm.booking,
                            "property-mutator": _vm.propertyMutator,
                            field: "marketing_channels",
                            "field-type": "multi-select",
                            "multi-select-types": ["marketing_channel"],
                            label: "* Marketing Channels",
                          },
                        }),
                        _vm._v(" "),
                        _c("ul", { staticClass: "more-details" }, [
                          _c(
                            "li",
                            [
                              _vm._v(
                                "\n              Do you require an In Person Shoot\n\n              "
                              ),
                              _c("toggle-button", {
                                staticClass: "pull-right",
                                attrs: {
                                  sync: true,
                                  color: {
                                    checked: _vm.brandPrimary,
                                    unchecked: "#b7b7b7",
                                  },
                                },
                                model: {
                                  value: _vm.$v.shoot_required.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.shoot_required,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.shoot_required.$model",
                                },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "expenses_covered",
                                },
                                domProps: {
                                  value: _vm.$v.shoot_required.$model,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$vlastMode &&
      this.booking.custom_fields &&
      this.booking.custom_fields.length > 0
        ? [
            _c("div", { staticClass: "panel panel-send-request" }, [
              _c("div", { staticClass: "panel-body" }, [
                _c("h3", [
                  _vm._v(
                    "Additional " + _vm._s(_vm.$t("request")) + " details"
                  ),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  _vm._l(_vm.booking.custom_fields, function (field, index) {
                    return _c("div", { key: field.name }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(_vm._s(field.name)),
                        ]),
                        _vm._v(" "),
                        field.dataType === "text" ||
                        field.dataType === undefined
                          ? _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.booking.custom_fields[index].value,
                                    expression:
                                      "booking.custom_fields[index].value",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text", maxlength: "1024" },
                                domProps: {
                                  value: _vm.booking.custom_fields[index].value,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.booking.custom_fields[index],
                                      "value",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        field.dataType === "file"
                          ? _c(
                              "div",
                              [
                                _c("file-input", {
                                  attrs: { prefix: "booking-custom-fields" },
                                  model: {
                                    value:
                                      _vm.booking.custom_fields[index].value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.booking.custom_fields[index],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "booking.custom_fields[index].value",
                                  },
                                }),
                              ],
                              1
                            )
                          : field.dataType === "date"
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "calendar-group" },
                                [
                                  _c("flat-pickr", {
                                    staticClass: "form-control pickdate",
                                    attrs: {
                                      config: _vm.flatPickerSingleDateConfig,
                                      name: "date",
                                    },
                                    model: {
                                      value:
                                        _vm.booking.custom_fields[index].value,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.booking.custom_fields[index],
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "booking.custom_fields[index].value",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : field.dataType === "dropdown"
                          ? _c(
                              "div",
                              [
                                _c("selectize", {
                                  staticClass:
                                    "selectize selectize-single w-full",
                                  attrs: {
                                    name: "timezone",
                                    options: _vm.getListOptions(
                                      field.listOptions
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.booking.custom_fields[index].value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.booking.custom_fields[index],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "booking.custom_fields[index].value",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._l(
        _vm.$requestFormConfig.shortlist_before_deliverables
          ? ["shortlist", "files", "deliverables", "video_message"]
          : ["deliverables", "video_message", "files", "shortlist"],
        function (panel) {
          return [
            panel === "deliverables"
              ? _c(
                  "div",
                  { key: panel, staticClass: "panel panel-send-request" },
                  [
                    _c("div", { staticClass: "panel-body" }, [
                      _c("h3", [
                        _vm._v(
                          _vm._s(
                            _vm._f("sentenceCase")(_vm.$t("your deliverables"))
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: _vm.hasErrorClass(
                            _vm.$v.description,
                            "form-group"
                          ),
                        },
                        [
                          _c("label", { staticClass: "control-label" }, [
                            _vm._v(
                              "\n              * " +
                                _vm._s(
                                  _vm.$tc("request_stars.deliverables_title")
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "redactor-editor-wrapper" },
                            [
                              _c("redactor", {
                                attrs: {
                                  name: "description",
                                  placeholder: _vm.$tc(
                                    "request_stars.deliverables_example"
                                  ),
                                  options: _vm.redactorOptions,
                                },
                                model: {
                                  value: _vm.$v.description.$model,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.$v.description, "$model", $$v)
                                  },
                                  expression: "$v.description.$model",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: {
                              field: _vm.$v.description,
                              label: "Description",
                            },
                          }),
                          _vm._v(" "),
                          _vm.$t("request_stars.deliverables_description")
                            ? _c(
                                "p",
                                { staticStyle: { "white-space": "pre" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "request_stars.deliverables_description"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showInPersonBooking && _vm.$showDressCode
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                class: _vm.hasErrorClass(
                                  _vm.$v.dress_code,
                                  "form-group"
                                ),
                              },
                              [
                                _c("label", { staticClass: "control-label" }, [
                                  _vm._v("Dress Code"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-group w-full" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.dress_code.$model,
                                          expression: "$v.dress_code.$model",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        name: "dress_code",
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.$v.dress_code.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.dress_code,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("vuelidate-help", {
                                  attrs: {
                                    field: _vm.$v.dress_code,
                                    label: "Dress code",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$v.requirements.$model
                        ? _c("div", { staticClass: "form-group" }, [
                            _c("label", { staticClass: "control-label" }, [
                              _vm._v(
                                _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)) +
                                  " requirements –\n              "
                              ),
                              _c("span", { staticClass: "small" }, [
                                _vm._v(
                                  "tell us in as much detail as you can what you want the " +
                                    _vm._s(_vm.$starLabel) +
                                    " to do"
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.$v.requirements.$model,
                                  expression: "$v.requirements.$model",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "requirements",
                                name: "requirements",
                                rows: "6",
                                placeholder:
                                  "For example: I want the sports star to mingle with event attendees for 30 minutes, signing autographs and posing for photos with fans etc. Then take part in a 30 minute Q and A interview about their career, talking about overcoming adversity and lessons learned. I would then like the talent to post a photo from the event to their Instagram account.",
                              },
                              domProps: { value: _vm.$v.requirements.$model },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.$v.requirements,
                                    "$model",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.showInPersonBooking
                              ? _c("p", { staticClass: "requirements-info" }, [
                                  _vm._v(
                                    "\n              Important: When " +
                                      _vm._s(_vm.$starLabelPlural) +
                                      " are required to complete a promotional or branded post on their social media accounts, it is likely this will need to be disclosed as advertising (e.g. #ad or #spon). To find out if this is relevant to you, read more\n              "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        href: _vm.socialMediaDisclosureLink,
                                      },
                                    },
                                    [_vm._v("here")]
                                  ),
                                  _vm._v(" "),
                                  !_vm.$vlastMode
                                    ? _c("span", [
                                        _vm._v("\n               or email "),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "mailto:" +
                                                _vm.$user.region.admin_email,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$user.region.admin_email
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          " if you have any questions.\n            "
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.clientName === "auscricket"
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "col-md-4",
                                class: _vm.hasErrorClass(
                                  _vm.$v.aca_number_participants,
                                  "filter form-group"
                                ),
                              },
                              [
                                _c("label", { staticClass: "control-label" }, [
                                  _vm._v(
                                    "* Approximate number of participants"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.$v.aca_number_participants.$model,
                                        expression:
                                          "$v.aca_number_participants.$model",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      name: "aca_number_participants",
                                      type: "number",
                                      min: "1",
                                    },
                                    domProps: {
                                      value:
                                        _vm.$v.aca_number_participants.$model,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.$v.aca_number_participants,
                                          "$model",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "input-group-addon" },
                                    [_vm._v("Participant(s)")]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-md-8",
                                class: _vm.hasErrorClass(
                                  _vm.$v.aca_participant_ability,
                                  "filter form-group"
                                ),
                              },
                              [
                                _c("label", { staticClass: "control-label" }, [
                                  _vm._v("* Participant age and ability"),
                                ]),
                                _vm._v(" "),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.$v.aca_participant_ability.$model,
                                      expression:
                                        "$v.aca_participant_ability.$model",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { name: "aca_participant_ability" },
                                  domProps: {
                                    value:
                                      _vm.$v.aca_participant_ability.$model,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.$v.aca_participant_ability,
                                        "$model",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("ul", { staticClass: "more-details" }, [
                        !_vm.$vlastMode
                          ? _c(
                              "li",
                              [
                                _vm._v(
                                  "\n              I will cover travel and accommodation expenses (if applicable)\n\n              "
                                ),
                                _c("toggle-button", {
                                  staticClass: "pull-right",
                                  attrs: {
                                    sync: true,
                                    color: {
                                      checked: _vm.brandPrimary,
                                      unchecked: "#b7b7b7",
                                    },
                                  },
                                  model: {
                                    value: _vm.$v.expenses_covered.$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.expenses_covered,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression: "$v.expenses_covered.$model",
                                  },
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  attrs: {
                                    type: "hidden",
                                    name: "expenses_covered",
                                  },
                                  domProps: {
                                    value: _vm.$v.expenses_covered.$model,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$vlastMode && !_vm.$hidePublicPromotingStatus
                          ? _c(
                              "li",
                              [
                                _vm._v(
                                  "\n              I am promoting this " +
                                    _vm._s(_vm.$t("request")) +
                                    " publicly\n\n              "
                                ),
                                _c("toggle-button", {
                                  staticClass: "pull-right",
                                  attrs: {
                                    sync: true,
                                    color: {
                                      checked: _vm.brandPrimary,
                                      unchecked: "#b7b7b7",
                                    },
                                  },
                                  model: {
                                    value: _vm.$v.promoted_publicly.$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.promoted_publicly,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression: "$v.promoted_publicly.$model",
                                  },
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  attrs: {
                                    type: "hidden",
                                    name: "promoted_publicly",
                                  },
                                  domProps: {
                                    value: _vm.$v.promoted_publicly.$model,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            panel === "files" && _vm.$allowRequestFileUploads
              ? _c(
                  "div",
                  { key: panel, staticClass: "panel panel-send-request" },
                  [
                    _c(
                      "div",
                      { staticClass: "panel-body" },
                      [
                        _c("request-upload-files", {
                          attrs: { booking: _vm.booking },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            panel === "shortlist" &&
            (!_vm.bookingTypeIsBooking || _vm.duplicated)
              ? _c(
                  "div",
                  { key: panel, staticClass: "panel panel-send-request" },
                  [
                    _c(
                      "div",
                      { staticClass: "panel-body" },
                      [
                        _c("h3", [_vm._v(_vm._s(_vm.$t("Your Shortlist")))]),
                        _vm._v(" "),
                        _vm._t("shortlist"),
                        _vm._v(" "),
                        _vm.$userIsAdmin || _vm.$vlastMode
                          ? _c("ul", { staticClass: "more-details" }, [
                              _vm.$isNflClient && _vm.$userIsClient
                                ? _c(
                                    "li",
                                    [
                                      _vm._v(
                                        "\n              Player relations to add players\n              "
                                      ),
                                      _c("toggle-button", {
                                        staticClass: "pull-right",
                                        attrs: {
                                          color: {
                                            checked: _vm.brandPrimary,
                                            unchecked: "#b7b7b7",
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$billboardModuleEnabled
                                ? _c(
                                    "li",
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$tc("request_stars.make_public")
                                          ) +
                                          "\n\n              "
                                      ),
                                      _c("toggle-button", {
                                        staticClass: "pull-right",
                                        attrs: {
                                          sync: true,
                                          disabled: _vm.forceBillboard,
                                          color: {
                                            checked: _vm.brandPrimary,
                                            unchecked: "#b7b7b7",
                                          },
                                        },
                                        model: {
                                          value: _vm.$v.others_can_apply.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.others_can_apply,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.others_can_apply.$model",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        attrs: {
                                          type: "hidden",
                                          name: "others_can_apply",
                                        },
                                        domProps: {
                                          value: _vm.$v.others_can_apply.$model,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$userIsGlobalAdmin &&
                              _vm.regionOptions.length > 1
                                ? _c(
                                    "li",
                                    { staticClass: "flex items-center" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "spacer-r-1" },
                                        [_vm._v("Region")]
                                      ),
                                      _vm._v(" "),
                                      _c("selectize", {
                                        staticClass:
                                          "selectize selectize-single w-full",
                                        attrs: {
                                          name: "timezone",
                                          options: _vm.regionOptions,
                                        },
                                        model: {
                                          value: _vm.$v.region_id.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.region_id,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression: "$v.region_id.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            panel === "video_message" && _vm.fieldSetSelected("video_message")
              ? _c(
                  "div",
                  { key: panel, staticClass: "panel panel-send-request" },
                  [
                    _c("div", { staticClass: "panel-body" }, [
                      _c("h3", [_vm._v("Video Message Details")]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: _vm.hasErrorClass(
                            _vm.$v.video_caption,
                            "form-group"
                          ),
                        },
                        [
                          _c("label", { staticClass: "control-label" }, [
                            _vm._v(
                              "\n              * Video Content\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "redactor-editor-wrapper" },
                            [
                              _c("redactor", {
                                attrs: {
                                  name: "video_caption",
                                  placeholder:
                                    "Enter a description of what you'd like the talent to talk about. Serious or funny in nature? Do you have any funny stories or habits you want me to mention? What’s the special occasion or purpose?",
                                  options: _vm.redactorOptions,
                                },
                                model: {
                                  value: _vm.$v.video_caption.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.video_caption,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.video_caption.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("ul", { staticClass: "more-details" }, [
                        _c(
                          "li",
                          [
                            _vm._v(
                              "\n              Is this being used for commercial purposes\n              "
                            ),
                            _c("toggle-button", {
                              staticClass: "pull-right",
                              attrs: {
                                sync: true,
                                color: {
                                  checked: _vm.brandPrimary,
                                  unchecked: "#b7b7b7",
                                },
                              },
                              model: {
                                value: _vm.$v.commercial_purposes.$model,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.$v.commercial_purposes,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression: "$v.commercial_purposes.$model",
                              },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                type: "hidden",
                                name: "commercial_purposes",
                              },
                              domProps: {
                                value: _vm.$v.commercial_purposes.$model,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.$v.commercial_purposes.$model
                        ? _c(
                            "div",
                            [
                              _c("booking-field-input", {
                                attrs: {
                                  classes: _vm.hasErrorClass(
                                    _vm.$v.video_message_places,
                                    "form-group"
                                  ),
                                  booking: _vm.booking,
                                  "property-mutator": _vm.propertyMutator,
                                  validations: _vm.$v.video_message_places,
                                  field: "video_message_places",
                                  "other-field": "other_video_usage",
                                  "other-classes": _vm.hasErrorClass(
                                    _vm.$v.other_video_usage,
                                    "form-group"
                                  ),
                                  otherValidations: _vm.$v.other_video_usage,
                                  "field-type": "multi-select-options",
                                  options: _vm.videoMessageUsageLocationOptions,
                                  label: "* Usage Locations",
                                },
                              }),
                              _vm._v(" "),
                              _c("booking-field-input", {
                                attrs: {
                                  classes: _vm.hasErrorClass(
                                    _vm.$v.video_rights_length,
                                    "form-group"
                                  ),
                                  booking: _vm.booking,
                                  validations: _vm.$v.video_rights_length,
                                  "property-mutator": _vm.propertyMutator,
                                  field: "video_rights_length",
                                  "field-type": "select",
                                  options: _vm.rightsLengthOptions,
                                  label: "* Rights Length",
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("booking-field-input", {
                                attrs: {
                                  classes: _vm.hasErrorClass(
                                    _vm.$v.video_message_first_name,
                                    "form-group"
                                  ),
                                  booking: _vm.booking,
                                  "property-mutator": _vm.propertyMutator,
                                  validations: _vm.$v.video_message_first_name,
                                  field: "video_message_first_name",
                                  label: "* First Name",
                                },
                              }),
                              _vm._v(" "),
                              _c("booking-field-input", {
                                attrs: {
                                  classes: _vm.hasErrorClass(
                                    _vm.$v.video_message_last_name,
                                    "form-group"
                                  ),
                                  booking: _vm.booking,
                                  "property-mutator": _vm.propertyMutator,
                                  validations: _vm.$v.video_message_last_name,
                                  field: "video_message_last_name",
                                  label: "* Last Name",
                                },
                              }),
                            ],
                            1
                          ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        }
      ),
      _vm._v(" "),
      !_vm.$vlastMode
        ? _c("div", { staticClass: "panel panel-send-request" }, [
            _c("div", { staticClass: "panel-body" }, [
              _c("h3", [_vm._v("Coupon Code")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          If you have received a coupon code please enter it below.\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.lazy",
                          value: _vm.$v.coupon.$model,
                          expression: "$v.coupon.$model",
                          modifiers: { lazy: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: "coupon",
                        type: "text",
                        placeholder: "CODE123",
                      },
                      domProps: { value: _vm.$v.coupon.$model },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.$v.coupon,
                            "$model",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-btn" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button", title: "Clear", "data-clear": "" },
        },
        [
          _c("i", { staticClass: "fa fa-times" }, [
            _c(
              "span",
              { staticClass: "sr-only", attrs: { "aria-hidden": "true" } },
              [_vm._v("Clear")]
            ),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-btn" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button", title: "Clear", "data-clear": "" },
        },
        [
          _c("i", { staticClass: "fa fa-times" }, [
            _c(
              "span",
              { staticClass: "sr-only", attrs: { "aria-hidden": "true" } },
              [_vm._v("Clear")]
            ),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12 margin-b-2" }, [
      _c("strong", [_vm._v("Important:")]),
      _vm._v(
        " Both arrival and start times should be entered in the local time for event\n            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-addon" }, [
      _c("i", { staticClass: "fa fa-percent" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-addon" }, [
      _c("i", { staticClass: "fa fa-usd" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "\n                Please enter the total fee for this appearance based on the type and duration:"
      ),
      _c("br"),
      _vm._v(
        "\n                Metro: $150/hour (min. $300 for up to 2 hours)"
      ),
      _c("br"),
      _vm._v(
        "\n                Regional: $250/hour (min. $500 for up to 2 hours)"
      ),
      _c("br"),
      _vm._v(
        "\n                Round up to the nearest half hour when calculating total hours.\n              "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }